import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { Content } from './content';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { Wrapper } from './wrapper';

// // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const TitleContainerStyles = xcss({
	position: 'relative',
	font: 'font.heading.small',
	fontWeight: 'font.weight.medium',
	color: 'color.text',
	marginTop: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = ({ children }: { children: ReactNode }): React.JSX.Element => {
	return <Box xcss={TitleContainerStyles}>{children}</Box>;
};
